import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

import { useSelectFilter } from '@/scopes/search/search/domain/hooks'

import {
  Dropdown,
  DropdownOption,
  FormField,
  FormFieldControl,
  FormFieldLabel,
  SpaceBetween,
  tk,
} from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'

import * as React from 'react'
import { createSearchFilterClickEvent } from '../../../../domain/analytics'
import FilterGroup from './FilterGroup'

function DistanceToCenterFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isFetching, options, selectedValue, setSelection } = useSelectFilter('MetersToCenter')

  const handleFilterChange = (value?: string) => {
    if (value) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'distance from city center',
          result: value,
        }),
      )
    }
    else {
      setSelection(null)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <FormField>
      <FormFieldLabel>{intl.formatMessage({ id: 'distance_to_center_label' })}</FormFieldLabel>
      <FormFieldControl>
        <Dropdown
          placeholder={intl.formatMessage({ id: 'make_a_choice_placeholder' })}
          value={selectedValue}
          onValueChange={handleFilterChange}
          disabled={isFetching}
        >
          {options.map(({ name, value }) => (
            <DropdownOption key={value} value={value}>
              {name}
            </DropdownOption>
          ))}
        </Dropdown>
      </FormFieldControl>
    </FormField>
  )
}

function DistanceToBeachFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isFetching, options, selectedValue, setSelection } = useSelectFilter('MetersToBeach')

  const handleFilterChange = (value?: string) => {
    if (value) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'distance from sea',
          result: value,
        }),
      )
    }
    else {
      setSelection(null)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <FormField>
      <FormFieldLabel>{intl.formatMessage({ id: 'distance_to_beach_label' })}</FormFieldLabel>
      <FormFieldControl>
        <Dropdown
          placeholder={intl.formatMessage({ id: 'make_a_choice_placeholder' })}
          value={selectedValue}
          disabled={isFetching}
          onValueChange={handleFilterChange}
        >
          {options.map(({ name, value }) => (
            <DropdownOption key={value} value={value}>
              {name}
            </DropdownOption>
          ))}
        </Dropdown>
      </FormFieldControl>
    </FormField>
  )
}

export function DistanceToInterestsFilter() {
  const intl = useIntl()
  const { selectedValue: selectedMetersToBeachValue } = useSelectFilter('MetersToBeach')
  const { selectedValue: selectedMetersToCenterValue } = useSelectFilter('MetersToCenter')

  return (
    <FilterGroup
      title={intl.formatMessage({ id: 'distance_to_interests_label' })}
      defaultOpen={selectedMetersToBeachValue !== null || selectedMetersToCenterValue != null}
    >
      <SpaceBetween direction="y" spacing={tk('spacing_md')}>
        <DistanceToBeachFilter />
        <DistanceToCenterFilter />
      </SpaceBetween>
    </FilterGroup>
  )
}
